<script setup lang="ts">
import { SUPPORTED_PAGES_ENUM } from "~/common/breadCrumbs"
import HomeLayout from "~/layouts/HomeLayout.vue"

definePageMeta({
    layout: false,
})

useSeoMeta({
    title: "Mayorista",
    ogTitle: "Mayorista - Dapamas",
})

const wholesalePhone = "+525640046364"
const wholesalePhoneDisplay = "+52 56 4004 6364"
</script>
<template>
    <HomeLayout
        :title="'Mayorista'"
        :subtitle="''"
        :currentPage="SUPPORTED_PAGES_ENUM.Mayorista"
        withoutParentStyles
    >
        <section class="tw-py-16 max-container tw-flex tw-justify-center">
            <q-card
                class="tw-overflow-hidden tw-w-full md:tw-w-[85%] xl:tw-w-[70%] tw-shadow-md"
            >
                <div class="lg:tw-flex">
                    <div
                        class="bg-primary tw-text-white tw-p-8 lg:tw-p-12 tw-w-full lg:tw-w-2/5 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-6"
                    >
                        <div
                            class="tw-bg-white/15 tw-rounded-full tw-p-6 tw-flex tw-items-center tw-justify-center"
                        >
                            <q-icon
                                name="local_shipping"
                                size="80px"
                                color="white"
                            />
                        </div>
                        <div class="tw-text-center">
                            <h2
                                class="tw-text-2xl lg:tw-text-3xl tw-font-bold tw-mb-2"
                            >
                                Comercio Mayorista
                            </h2>
                            <p class="tw-text-white/85 tw-text-sm">
                                Soluciones a gran escala para tu negocio
                            </p>
                        </div>
                    </div>

                    <div
                        class="tw-p-8 lg:tw-p-12 tw-w-full lg:tw-w-3/5 tw-flex tw-flex-col tw-gap-6 tw-justify-center"
                    >
                        <div class="tw-flex tw-items-center tw-gap-3">
                            <q-icon
                                name="storefront"
                                size="32px"
                                color="secondary"
                            />
                            <p
                                class="tw-text-xl lg:tw-text-2xl tw-font-bold tw-text-primary"
                            >
                                ¿Interesado en comprar al por mayor?
                            </p>
                        </div>

                        <p
                            class="tw-text-base tw-text-customGray-500 tw-leading-relaxed"
                        >
                            Si está interesado en el comercio mayorista a través
                            de
                            <strong class="tw-text-primary">dapamas.com</strong
                            >, por favor contáctenos al
                            <a
                                :href="`tel:${wholesalePhone}`"
                                class="tw-text-secondary tw-font-bold tw-underline hover:tw-text-secondary-800"
                                >{{ wholesalePhoneDisplay }}</a
                            >
                            y le atenderemos con mucho gusto.
                        </p>

                        <div
                            class="tw-flex tw-flex-col sm:tw-flex-row tw-gap-3 tw-mt-2"
                        >
                            <a
                                :href="`tel:${wholesalePhone}`"
                                class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-bg-secondary hover:tw-bg-secondary-800 tw-text-white tw-font-bold tw-rounded-full tw-px-6 tw-py-3 tw-transition-colors tw-no-underline"
                            >
                                <q-icon name="phone" size="20px" />
                                Llamar ahora
                            </a>
                            <NuxtLink
                                to="/contact-us"
                                class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-border tw-border-primary tw-text-primary hover:tw-bg-primary hover:tw-text-white tw-font-bold tw-rounded-full tw-px-6 tw-py-3 tw-transition-colors tw-no-underline"
                            >
                                <q-icon name="mail" size="20px" />
                                Más formas de contacto
                            </NuxtLink>
                        </div>

                        <q-separator class="tw-my-2" />

                        <div
                            class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 tw-gap-4 tw-text-center"
                        >
                            <div
                                class="tw-flex tw-flex-col tw-items-center tw-gap-2"
                            >
                                <q-icon
                                    name="inventory_2"
                                    size="32px"
                                    color="secondary"
                                />
                                <span
                                    class="tw-text-sm tw-text-customGray-500 tw-font-semibold"
                                >
                                    Grandes volúmenes
                                </span>
                            </div>
                            <div
                                class="tw-flex tw-flex-col tw-items-center tw-gap-2"
                            >
                                <q-icon
                                    name="sell"
                                    size="32px"
                                    color="secondary"
                                />
                                <span
                                    class="tw-text-sm tw-text-customGray-500 tw-font-semibold"
                                >
                                    Precios preferenciales
                                </span>
                            </div>
                            <div
                                class="tw-flex tw-flex-col tw-items-center tw-gap-2"
                            >
                                <q-icon
                                    name="support_agent"
                                    size="32px"
                                    color="secondary"
                                />
                                <span
                                    class="tw-text-sm tw-text-customGray-500 tw-font-semibold"
                                >
                                    Atención personalizada
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </q-card>
        </section>
    </HomeLayout>
</template>
